import {useQuery} from '@tanstack/react-query';
import {useAccessToken} from '@salesforce/commerce-sdk-react';

import {useService} from '@amblique/king-living/app/hooks/use-service';
import {ConfigApiService} from '@amblique/king-living/app/services/config-api-service';

const SITE_CLIENT_DATA_STALE_MS = 5 * 60 * 1000;

/**
 * Loads whitelisted site client data via Custom SCAPI (`c_amb.utils`).
 * Mirrors `Site-ClientData` without hitting the storefront origin.
 * Shared cache key so multiple consumers reuse a single network request.
 *
 * @returns {import('@tanstack/react-query').UseQueryResult<{clientData?: object}>}
 */
export const useSiteClientData = () => {
  const configApiService = useService(ConfigApiService);
  const {getTokenWhenReady} = useAccessToken();

  return useQuery({
    enabled: configApiService instanceof ConfigApiService,
    queryFn: async () => {
      const accessToken = await getTokenWhenReady();

      return configApiService.getSiteClientData({
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
    },
    queryKey: [configApiService?.key, 'utils', 'site-client-data'],
    staleTime: SITE_CLIENT_DATA_STALE_MS,
  });
};
